<!-- DO NOT INCLUDE DIRECTLY -->
<!-- use intro.mixin.js -->
<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small class="pa-0 intro__btn" @click="click">
        <v-icon v-on="on" v-bind="attrs">mdi-help</v-icon>
      </v-btn>
    </template>
    <span>{{ title }}</span>
  </v-tooltip>
</template>

<script>
import i18n from '@/translations/lang'
export default {
  name: 'HelperTooltip',
  props: {
    title: {
      type: String,
      default: i18n.t('message.knowMore'),
    },
    click: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
$size: 1.35rem;

.bg-dark {
  .intro {
    &__btn {
      --intro-background-color: rgba(255, 255, 255, 0.54);
      --intro-foreground-color: #000;
    }
  }
}

.intro {
  &__btn {
    --intro-background-color: var(--v-neutral-lighten1);
    --intro-foreground-color: var(--v-neutral-lighten4);

    position: relative;
    top: 0.5px;

    &::v-deep {
      .v-icon {
        background-color: var(--intro-background-color);
        width: $size;
        height: $size;
        border-radius: 100%;

        &[class*='mdi-'] {
          font-size: $size * 0.8;

          &::before {
            color: var(--intro-foreground-color);
          }
        }
      }
    }
  }
}
</style>
